import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { RestApi } from "src/app/shared/RestApi/restApi";
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

export interface trnxCommonServiceInfo {
  statusMessage: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class ReporttemplateService {

  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi) { }

  async retrieveTrnxService(tableName) {

    this.spinner.start();

    console.log(this.restAPI.RETRIEVE_SCHEDULE_URL + "/" + tableName);

    let response = await this.http.get<trnxCommonServiceInfo>(this.restAPI.RETRIEVE_SCHEDULE_URL + "/" + tableName, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }

  async retrieveTrnxService1() {

    this.spinner.start();

    console.log(this.restAPI.RETRIEVE_FILTERS_URL);

    let response = await this.http.get<trnxCommonServiceInfo>(this.restAPI.RETRIEVE_FILTERS_URL, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

    /**
	 * @Author Abhishek Tomar
	 * @CreatedDate 04/06/2024
	 * Retriving the filtermanage based on datasetid
	 */
  }
  async retrieveFiltermanagebyDataSetid(datasetid) {

    this.spinner.start();

    let response = await this.http.get<trnxCommonServiceInfo>(this.restAPI.RETRIEVE_FILTERS + "/" + datasetid, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }
/**
 * @author Bhor S
 * @CreatedDate 11/4/2025
 * @param filterid 
 * @returns 
 */
  async retrieveFiltermanagebyFilterid(filterid) {

    this.spinner.start();

    let response = await this.http.get<trnxCommonServiceInfo>(this.restAPI.RETRIEVE_FILTERS + "/" +"filter/"+filterid, { headers: this.headers }).toPromise();

    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

      return null;

    }
    else {

      this.spinner.stop();

      return response;

    }

  }
}
